<template>
  <div class="login-wrap login-wrap-kfpt">
    <div class="head-logo">
      <img src="../../static/img/logo.png" alt="">
    </div>
    <div class="kfpt-login-container mt60">
<!--      <div class="login_left_box">-->
<!--        <img src="../../static/img/moligou_login_left.png" alt="">-->
<!--      </div>-->
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="kfpt-demo-ruleForm">
        <div class="el-logo-img">
          <img src="static/img/kfpt_title.png">
        </div>
        <el-form-item prop="username">
          <div class="el-input-zh el-input-kfpt">
            <el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="请输入用户名" style="height: 52px;line-height: 52px;width: 320px"></el-input>
            <span><img src="../../static/img/username.svg"></span>
          </div>
        </el-form-item>

        <el-form-item prop="password">
          <div class="el-input-zh el-input-kfpt">
            <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="请输入密码" style="height: 52px;line-height: 52px;width: 320px"></el-input>
            <span><img src="../../static/img/password.svg"></span>
          </div>
        </el-form-item>
        <el-row class="el-row-col">
          <el-col :span="12">
            <el-form-item prop="verification">
              <div class="el-input-yzm el-input-kfpt">
                <el-input type="text" v-model="ruleForm.verification" auto-complete="off" placeholder="请输入红色验证码" @keyup.enter.native="submitForm('ruleForm')"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="code-box">
            <img :src="codeimg" alt="" class="codeimg" @click="getcode()" style="height: 52px">
          </el-col>
        </el-row>
        <div class="el-button-nue">
          <el-form-item style="width:100%;margin-bottom: 20px">
            <el-button type="primary" style="width:100%;" class="login-button-kfpt"
                       @click="submitForm('ruleForm')" :loading="logining">立即登录</el-button>
          </el-form-item>
        </div>
<!--        <div class="el-link-line">-->
<!--          <el-link :underline="false" type="primary">忘记密码</el-link>-->
<!--          <el-link :underline="false" type="primary">立即注册</el-link>-->
<!--        </div>-->
      </el-form>
    </div>
    <div class="el-footer">
      <div class="el-frame">
        <div class="el-item">
          <p class="el-item-title mb20">服务支持</p>
          <p class="el-item-script">商家开发文档</p>
          <p class="el-item-script">品牌供应商开发文档</p>
          <p class="el-item-script">品牌客服开发文档</p>
          <p class="el-item-script">牙骑士开发文档</p>
          <p class="el-item-script">
            <el-link :underline="false" style="color: #999999" href="https://open.202832.com/console/#/?groupId=1830862921670361090&sortId=1830863296011993089&docId=1830863934477336578" target="_blank">第三方软件服务商开发文档</el-link>
          </p>
        </div>
        <div class="el-item ml176">
          <p class="el-item-title mb20">产品链接</p>
          <p class="el-item-script">
            <el-link :underline="false" style="color: #999999" href="https://www.202832.com/v2/" target="_blank">松佰商城</el-link>
          </p>
          <p class="el-item-script">
            <el-link :underline="false" style="color: #999999" href="http://www.yaqishi.com/" target="_blank">牙骑士</el-link>
          </p>
          <p class="el-item-script">
            <el-link :underline="false" style="color: #999999" href="https://www.202832.com/v2/sxb/sxbindex.html" target="_blank">松小佰</el-link>
          </p>
          <p class="el-item-script">
            <el-link :underline="false" style="color: #999999" href="https://mer.202832.com/" target="_blank">商家后台</el-link>
          </p>
        </div>
        <div class="el-item ml176">
          <p class="el-item-title mb20">联系我们</p>
          <p class="el-item-script">客服 400-8202832</p>
        </div>
        <div class="el-item ml176">
          <p class="el-item-title">关注我们</p>
          <div class="el-code">
            <img src="../../static/img/code.png">
          </div>
        </div>
      </div>
      <div class="copy-text">Copyright © 2015 - 2025湖南展博科技发展有限公司 版权所有</div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import { login } from '../api/userMG'
  import axios from 'axios';
  import { setCookie, getCookie, delCookie } from '../utils/util'
  export default {
    name: 'login',
    data() {
      return {
        //定义loading默认为false
        logining: false,
        ruleForm: {
          //username和password默认为空
          username: '',
          password: '',
          verification: ''
        },
        codeimg:'',
        //rules前端验证
        rules: {
          username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          verification: [{ required: true, message: '请填写红色数字', trigger: 'blur' }]
        },
        urlPathName:''
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.urlPathName = window.location.pathname;
      // 获取图形验证码
      this.getcode()
      // 获取存在本地的用户名密码
      this.getuserpwd()
    },
    // 里面的函数只有调用才会执行
    methods: {
      getcode() {
        axios({
          method: 'get',
          url: '/api/noauth/verification',
          headers: {
            'Content-Type': 'application/json;charset:utf-8',
          },
          data: {},
          traditional: true,
          responseType: 'blob',
        }).then(res => {
          localStorage.setItem('verificationid',res.headers.verificationid)
          this.codeimg = window.URL.createObjectURL(res.data);
        });
      },
      // 获取用户名密码
      getuserpwd() {
        if (getCookie('user') != '' && getCookie('pwd') != '') {
          this.ruleForm.username = getCookie('user')
          this.ruleForm.password = getCookie('pwd')
        }
      },
      //获取info列表
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.logining = true
            // 测试通道，不为空直接登录
            // setTimeout(() => {
            //   this.logining = false
            //   this.$store.commit('login', 'true')
            //   this.$router.push({ path: '/dashboard/Dashboard' })
            // }, 1000)
            // 注释
            let data = {
              username: this.ruleForm.username,
              password:this.ruleForm.password,
              verification: this.ruleForm.verification,
            }
            login(data).then(res => {
              if (res.success) {
                if (this.rememberpwd) {
                  //保存帐号到cookie，有效期7天
                  setCookie('user', this.ruleForm.username, 7)
                  //保存密码到cookie，有效期7天
                  setCookie('pwd', this.ruleForm.password, 7)
                } else {
                  delCookie('user')
                  delCookie('pwd')
                }
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  this.logining = false
                  // 缓存token
                  // localStorage.setItem('logintoken', res.content.tokenId)
                  localStorage.setItem('userName', res.content.username)
                  localStorage.setItem('lastLoginTime', res.content.last_login_time)
                  localStorage.setItem('songbai_system', res.content.songbai_system)
                  localStorage.setItem('isSuper', res.content.super_admin==true?'1':'0')
                  localStorage.setItem('login_url', window.location.href)
                  this.$store.commit('login', 'true')
                  this.$store.commit('setTokenId', res.content.tokenId)
                  this.$store.commit('setCustId', res.content.cust_id)
                  this.$router.push({ path: '/Document/typeDocument' })
                  localStorage.setItem('path','/Document/typeDocument')
                  this.$message({
                    type: 'success',
                    message: '登录成功!'
                  })
                }, 1000)
              } else {
                this.$message.error(res.msg)
                this.getcode()
                this.logining = false
                return false
              }
            })
          } else {
            // 获取图形验证码
            this.getcode()
            this.logining = false
            return false
          }
        })
      },
    }
  }
</script>

<style scoped>
  /*.login-wrap {*/
  /*  box-sizing: border-box;*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*  !*padding-top: 10%;*!*/
  /*  background-image: url("../../static/img/login_bg.png");*/
  /*  !* background-color: #112346; *!*/
  /*  background-repeat: no-repeat;*/
  /*  background-position: center right;*/
  /*  background-size: 100%;*/
  /*}*/
  .login-wrap-kfpt {
    box-sizing: border-box;
    width: 100%;
    height: 1080px;
    /*padding-top: 10%;*/
    background-image: url("../../static/img/kfpt_bg.png");
    /* background-color: #112346; */
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 100%;
  }
  /deep/.kfpt-login-container .el-form-item {
    margin-bottom: 43px !important;
  }

  /deep/ .el-button-nue .el-form-item__content {
    text-align: center !important;
  }
  /deep/ .el-button-nue .el-button--primary {
    border-radius: 12px !important;
  }
  /deep/ .el-button-nue .el-form-item {
    margin-bottom: 20px !important;
  }
  /deep/ .el-row-col .el-form-item {
    margin-bottom: 53px !important;
  }

  .code-box {
    text-align: right;
  }
  .codeimg {
    height: 40px;
  }
  .el-logo-img {
    width: 144.81px;
    height: 40px;
    margin: 0 auto 30px;
  }
  .el-logo-img img {
    width: 100%;
  }

  .el-input-zh {
    position: relative;
    background: #F4F4F4;
    border-radius: 8px;
    padding: 0 56px 0 0;
  }
  /deep/ .el-input-zh .el-input__inner {
    border: 0 !important;
    background: #f4f4f4 !important;
    border-radius: 8px !important;
    padding: 0 0 0 15px !important;
  }
  /deep/ .el-input-kfpt .el-input__inner {
    height: 52px;
    line-height: 52px;
  }
  .el-input-yzm {
    background: #F4F4F4;
    border-radius: 8px;
  }
  /deep/ .el-input-yzm .el-input__inner {
    border: 0 !important;
    background: #f4f4f4 !important;
    border-radius: 8px !important;
  }
  .el-input-zh span {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 8px;
    right: 16px;
  }
  .el-input-zh span img {
    width: 100%;
  }
  .copy-text {
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 17px;
    color: #999999;
    margin-top: 30px;
  }
  .login-button-kfpt {
    background: linear-gradient(90deg, #98D4FF 0%, #76A0FF 100%);
    height: 62px;
    border: 0;
  }
  .login_left_box {
    margin-right: 15px;
    display: inline-block;
  }
  .kfpt-login-container {
    background: #FFFFFF;
    box-shadow: 0px 10px 40px rgba(0, 133, 208, 0.3);
    border-radius: 12px;
    margin-left: 55%;
    padding: 60px 84px 80px 84px;
    text-align: left;
    width: 375px;
  }
  .kfpt-demo-ruleForm {
    display: inline-block;
  }

  .login_left_box img {
    width: 494px;
    height: 352px;
  }

  .mt60 {
    margin-top: 60px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .head-logo {
    padding: 15px 0 15px 30px;
    background: #FFFFFF;
    border-bottom: 2px solid #E6E6E6;
  }

  .head-logo img {
    width: 156px;
    height: 24px;
  }

  .el-link-line {
    width: 100%;
    height: 24px;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    justify-content: space-between;
  }

  .el-footer {
    width: 100%;
    height: 291px;
    padding: 30px 480px 40px 480px;
    background: #333333;
    margin-top: 58px;
  }

  .el-frame {
    width: 961px;
    height: 174px;
    display: flex;
    justify-content: space-between;
  }

  .el-item {
    overflow: hidden;
  }

  .el-item-title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: #FFFFFF;
  }

  .el-item-script {
    font-size: 14px;
    line-height: 18px;
    color: #999999;
    margin-bottom: 10px;
  }

  .el-code {
    width: 104px;
    height: 104px;
    background: #FFFFFF;
    padding: 10px;
    border-radius: 10px;
    margin-top: 10px;
  }

  .el-code img {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/login.vue